import { RootState } from '@/app/globalRedux/store'
import useLoginRouter from '@/app/hooks/useLoginRouter'
import { useTranslation } from '@/app/i18n/client'
import { Subscription } from '@/app/types/offersType'
import { Button } from '@/components/ui/button'
import Image from 'next/image'
import React from 'react'
import { useSelector } from 'react-redux'

const SalesOffersBlocker: React.FC<Subscription> = ({
  name,
  limit,
  isBeneficiary,
}) => {
  const { t } = useTranslation()
  const navigateToLogin = useLoginRouter()
  const loggedIn = useSelector((state: RootState) => state?.user?.loggedIn)
  const plan = useSelector((state: RootState) => state.user.userSubscription)
  return (
    <div className=" flex flex-col justify-center items-center gap-3 w-full">
      <div className=" flex flex-row gap-2">
        <Image
          height={17.5}
          width={18.9}
          alt="Warning-Icon"
          src={'/assets/Icons/WarningIcon.svg'}
        />
        <div className="text-[20px] text-[#222222] font-bold">
          {t('Your limit exhausted')}!
        </div>
      </div>
      <div className="flex flex-col gap-2 items-center">
        <p className="text-[14px] text-[#6f6f6f] mobile:text-center">
          {plan !== 'Platinum'
            ? t(
                'Upgrade to unlock more premium features and benefits or wait for renewal'
              )
            : t('Kindly wait for renewal of quota')}
        </p>
        <div className=" flex flex-row">
          {!loggedIn ? (
            <p className="text-[14px] text-[#222222] ml-1 gap-[1px] font-bold">
              {t('Login to access this feature')}
            </p>
          ) : isBeneficiary ? (
            <>
              <p className="text-[14px] text-[#6f6f6f]">{`${t('Current plan')} :`}</p>
              <p className="text-[14px] text-[#222222] ml-1 gap-[1px] font-bold">
                {limit == '-1' ? `${name}` : `${limit} ${t('profiles/week')}`}
              </p>
            </>
          ) : (
            <p className="text-[14px] text-[#222222] ml-1 gap-[1px] font-bold">
              {t('You are not an Beneficiary user')}
            </p>
          )}
        </div>
      </div>
      {name === 'Logged out' ? (
        <>
          <Button
            variant="secondary"
            size="sx"
            className="mt-4 py-3  text-[14px] font-bold"
            onClick={() => {
              navigateToLogin('login')
            }}
          >
            {t('LOGIN')}
          </Button>
        </>
      ) : plan !== 'Platinum' ? (
        <Button
          variant="secondary"
          size="sx"
          className="mt-4 py-3  text-[14px] font-bold"
        >
          <a href={loggedIn ? '/member/profile' : '/solutions/for_buyers'}>
            {t('UPGRADE')}
          </a>
        </Button>
      ) : null}
    </div>
  )
}

export default SalesOffersBlocker
